import {
  GET_RELATED_REQUEST,
  GET_RELATED_REQUEST_FAILED,
  GET_RELATED_REQUEST_SUCCEEDED
} from "../constants/related";

export const related = (
  state = {
    isFetching: false,
    data: {},
    error: {},
  }, action) => {
  let newState = {...state};

  switch (action.type) {
    case GET_RELATED_REQUEST:
      newState.isFetching = true;
      return newState;

    case GET_RELATED_REQUEST_SUCCEEDED:
      newState.isFetching = false;
      newState.data = action.data;
      newState.error = {};
      return newState;

    case GET_RELATED_REQUEST_FAILED:
      newState.isFetching = false;
      newState.error = action.error;
      newState.data = {};
      return newState;

    default:
      return newState;
  }
};
